import { captureMessage } from '@sentry/browser';

const SENTRY_MODULE_TAG = 'easyclaim.app';

export function reportWarning(message: string, extra?: Record<string, unknown>): void {
	captureMessage(message, {
		level: 'warning',
		tags: { module: SENTRY_MODULE_TAG },
		extra,
	});
}
